//Install
import React, { Component } from "react";
//Install
import { ReactComponent as Arrow } from "../../../../Media/Icon/002.svg";

//Element
class Menu extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("menu", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB u9g2b1" },
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/en" },
                    //Element
                    "Home"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d cH8711" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "#" },
                    //Element
                    "Corporate"
                ),
                //Element
                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB gBt584" },
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/about-us" },
                            //Element
                            "About Us",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/offices" },
                            //Element
                            "Offices",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/history" },
                            //Element
                            "History",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/authorization-certificates" },
                            //Element
                            "Certificates",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    )
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d cH8711" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "#" },
                    //Element
                    "Our Services"
                ),
                //Element
                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB gBt584" },
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/lighting-systems" },
                            //Element
                            "Lighting Systems",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/electrical-panel-manufacturing" },
                            //Element
                            "Electrical Panel Manufacturing",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/electrical-contracting" },
                            //Element
                            "Electrical Contracting",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/renewable-energy" },
                            //Element
                            "Renewable Energy",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/medium-voltage-systems" },
                            //Element
                            "Medium Voltage Systems",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    )
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/en/projects" },
                    //Element
                    "Projects"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/en/sustainability" },
                    //Element
                    "Sustainability"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/en/career" },
                    //Element
                    "Career"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/en/contact" },
                    //Element
                    "Contact"
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Menu;